<template>
  <v-row>
    <v-col cols="12">
      <v-row justify="end" class="mt-1">
        <v-col cols="2">
          <v-select
            dense
            outlined
            v-model="productId"
            :items="products"
            item-text="description"
            item-value="id"
            label="Plano"
            :clearable="true"
            :loading="products.length==0"
            @change="loadItems"
          ></v-select>
        </v-col>
      </v-row>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalElements"
        :loading="isSearching"
        item-key="id"
        locale="pt-BR"
        show-select
        class="elevation-3"
      >
        <template v-slot:item.description="{item}">
          <acceptance-rule-descriptions
            :item="item"
            :acceptance-rule-descriptions="getAcceptanceRuleDescriptions"
            @on-description-created="updateAcceptanceRulePlan"
            class="mt-1 mb-1"
          >
          </acceptance-rule-descriptions>
        </template>
      </v-data-table>
    </v-col>
    <DlgConfirmCancel ref="confirm"></DlgConfirmCancel>
  </v-row>
</template>

<script>
import AcceptanceRulePlanService from '@/services/insurancepricing/AcceptanceRulePlanService';
import AcceptanceRuleDescriptions from '@/view/acceptance_rule/acceptance_rule_descriptions';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import DlgConfirmCancel from '@/components/dlg-confirm_cancel.vue';

export default {
  components: {AcceptanceRuleDescriptions, DlgConfirmCancel},
  props: {
    acceptanceRuleId: {
      type: String,
    },
  },
  data() {
    return {
      headers: [
        {text: 'Operadora', value: 'plan.carrierName'},
        {text: 'Código', value: 'plan.productCode'},
        {text: 'Plano', value: 'plan.description'},
        {text: 'Descrição', value: 'description', sortable: false},
      ],
      isSearching: false,
      options: {},
      items: [],
      totalElements: null,
      singleSelect: false,
      selected: [],
      products: [],
      productId: null,
    };
  },
  async created() {
    this._acceptanceRulePlanService = new AcceptanceRulePlanService();
  },
  watch: {
    options: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters('acceptanceRule', ['getAcceptanceRuleDescriptions']),
  },
  methods: {
    ...mapActions('acceptanceRule', ['fetchAcceptanceRuleDescriptions']),
    ...mapMutations(['toogleDialogLoading', 'showmsg']),
    async updateAcceptanceRulePlan(
      acceptanceRulePlan,
      acceptanceRuleDescriptionId,
    ) {
      const bodyFormData = new FormData();
      bodyFormData.append(
        'acceptanceRuleDescriptionId',
        acceptanceRuleDescriptionId,
      );
      await this._acceptanceRulePlanService.update(
        this.acceptanceRuleId,
        acceptanceRulePlan.id,
        bodyFormData,
      );
    },
    async loadData() {
      this.loadItems().then();
      this.loadProducts().then();
    },
    async loadItems() {
      this.isSearching = true;
      const {sortBy, sortDesc, page, itemsPerPage} = this.options;
      this._acceptanceRulePlanService
        .findAllByAcceptanceRuleId(this.acceptanceRuleId, {
          page: page ? page - 1 : 0,
          sortBy:
            sortBy && sortBy.length
              ? sortBy[0] === 'plan.carrierName'
                ? 'plan.productFamily.carrier.name'
                : sortBy[0]
              : 'plan.productCode',
          descending: sortDesc && sortDesc.length ? sortDesc[0] : false,
          size: itemsPerPage,
          planId: this.productId,
        })
        .then((res) => {
          this.items = res.data.content;
          this.totalElements = res.data.totalElements;
          this.isSearching = false;
          this.$emit('on-load');
        });

      if (!this.getAcceptanceRuleDescriptions.length) {
        this.fetchAcceptanceRuleDescriptions(this.acceptanceRuleId).then();
      }
    },
    async loadProducts() {
      this.products = [];
      this._acceptanceRulePlanService
        .findAllByAcceptanceRuleId(this.acceptanceRuleId, {
          page: 0,
          sortBy: 'plan.description',
          descending: false,
          size: this.totalElements,
        })
        .then((res) => {
          this.products = res.data.content.map((item) => item.plan);
        });
    },
    async removeAll() {
      if (
        this.selected.length &&
        (await this.$refs.confirm.show(
          'Atenção',
          'Deseja excluir os registros selecionados?',
        ))
      ) {
        this.toogleDialogLoading(true);
        try {
          for (const acceptanceRulePlan of this.selected) {
            await this._acceptanceRulePlanService.delete(
              this.acceptanceRuleId,
              acceptanceRulePlan.id,
            );
          }
          this.showmsg({text: 'Planos desassociados com sucesso!'});
        } catch (error) {
          this.showmsg({text: 'Erro ao desassociaar Planos!'});
        }

        this.toogleDialogLoading(false);
        await this.loadData();
      }
    },
  },
};
</script>
